import { BaseXHR } from 'utils/axios';

export const reindexURLApi = (data: { url: string }) =>
  BaseXHR.$post('seo/reindex-url', data);
